import { HomeIcon, LibraryIcon, NoteIcon, TimeIcon } from "../assets/svg-icons"
import HomeScreen from "../screens/HomeScreen"
import LibraryScreen from '../screens/LibraryScreen';
import { User } from 'react-huge-icons/outline';
import ProfileScreen from '../screens/ProfileScreen';
import WorkoutScreen from '../screens/WorkoutScreen';
import MeetingsScreen from '../screens/MeetingsScreen/MeetingsScreen';
import ActiveWorkoutScreen from "../screens/ActiveWorkoutScreen";
import HistoryWorkoutsScreen from "../screens/HistoryWorkoutsScreen";

interface IRoute {
    icon: (props: IRouteIconProps) => JSX.Element
    href: string
    label: string
    showInDrawer?: boolean
    element: JSX.Element
    authRequired?: boolean;
    showInBottomTabs?: number;
    hideFromMenu?: boolean;
}

type TRoutes = IRoute[]

interface IRouteIconProps {
    className?: string
}

const Routes: TRoutes = [
    {
        icon: (props) => <HomeIcon {...props} />,
        href: '/',
        label: 'Home',
        element: <HomeScreen />,
        showInBottomTabs: 0
    },
    // {
    //     icon: (props) => <LibraryIcon {...props} />,
    //     href: '/library',
    //     label: 'Library',
    //     showInDrawer: true,
    //     element: <LibraryScreen />
    // },
    {
        icon: (props) => <LibraryIcon {...props} />,
        href: '/history',
        label: 'History',
        showInDrawer: true,
        element: <HistoryWorkoutsScreen />
    },
    // {
    //     icon: (props) => <NotificationIcon {...props} />,
    //     href: '/notifications',
    //     label: 'Notifications',
    //     element: <NotificationsScreen />,
    //     showInBottomTabs: 1
    // },
    // {
    //     icon: (props) => <ChatIcon {...props} />,
    //     href: '/chat',
    //     label: 'Chat',
    //     element: <ChatScreen />,
    //     showInBottomTabs: 3
    // },
    {
        icon: (props) => <NoteIcon {...props} />,
        href: '/workout',
        label: 'Workout',
        element: <WorkoutScreen />,
        showInDrawer: false,
        hideFromMenu: true,
    },
    {
        icon: (props) => <NoteIcon {...props} />,
        href: '/active',
        label: 'Active',
        element: <ActiveWorkoutScreen />,
        showInBottomTabs: 2
    },
    // {
    //     icon: (props) => <BookIcon {...props} />,
    //     href: '/user-guide',
    //     label: 'User Guide',
    //     showInDrawer: true,
    //     element: <UserGuideScreen />
    // },
    // {
    //     icon: (props) => <TimeIcon  {...props} />,
    //     href: '/meetings',
    //     label: 'Meetings',
    //     showInDrawer: true,
    //     element: <MeetingsScreen />
    // },
    // {
    //     icon: (props) => <MailIcon {...props} />,
    //     href: '/pmo',
    //     label: 'Inbox / Outbox',
    //     showInDrawer: true,
    //     element: <InboxOutboxScreen />
    // },
    {
        icon: (props) => <User {...props} />,
        href: '/my-profile',
        label: 'My Profile',
        element: <ProfileScreen />,
        hideFromMenu: true,
        showInBottomTabs: 4
    }
]

export default Routes;